import { Reducer } from 'redux';
import { INITIAL_DETAILED_CLAIM_STATE } from '../../constants';
import {
    DETAILED_CLAIM_CLEAR,
    DETAILED_CLAIM_GET,
    DETAILED_CLAIM_LOADED,
    DetailedClaimActions,
} from '../actions/detailedClaimActions';
import { DetailedClaimState } from '../types';

export const detailedClaimReducer: Reducer<DetailedClaimState, DetailedClaimActions> = (
    state = INITIAL_DETAILED_CLAIM_STATE,
    action
): DetailedClaimState => {
    switch (action.type) {
        case DETAILED_CLAIM_GET:
            return {
                ...state,
                detailedClaim: {
                    value: action.payload.value,
                    error: action.payload.error,
                    status: action.payload.status,
                },
            };
        case DETAILED_CLAIM_LOADED:
            return {
                ...state,
                detailedClaim: {
                    value: action.payload.value,
                    error: action.payload.error,
                    status: action.payload.status,
                },
            };
        case DETAILED_CLAIM_CLEAR:
            return {
                ...state,
                ...INITIAL_DETAILED_CLAIM_STATE,
            };
        default:
            return state;
    }
};
